export default "/assets/images/hw-carbon.a59a3e09ad0d1037.webp";